// pages/DoctorMessagesPage.js
import React from 'react';
import MessagesContent from '../../components/MessagesContent';
import DashboardLayout from '../../components/layout/DashboardLayout';

const DoctorMessagesPage = () => {
  return (
      <DashboardLayout helpText="">
        <MessagesContent 
          userRole="doctor"
          nameField="patient" 
          specialtyField="last_appointment"
          useBackNav={false}
          useChatHeader={false}
          avatarInitial="P"
          messageColor="green"
          replyColor="red"
        />
    </DashboardLayout>
  );
};

export default DoctorMessagesPage;